var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "padding" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "經銷商" } },
                [
                  _c("selectCompany", {
                    attrs: { id: _vm.company_id },
                    on: {
                      "update:id": function ($event) {
                        _vm.company_id = $event
                      },
                      onSelect: _vm.onSelectCompany,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.selected.length
            ? _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.deleteInvoices },
                },
                [_vm._v(" 刪除 ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.size,
              layout: "sizes, prev, pager, next",
              total: _vm.invoices.count,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.invoices.rows, "row-class-name": _vm.statusClass },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { prop: "Period", label: "期別", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { prop: "Front", label: "字軌編號" },
          }),
          _c("el-table-column", {
            attrs: { prop: "Number", label: "發票號碼", sortable: "" },
          }),
          _c("el-table-column", {
            attrs: { label: "開立狀態", prop: "Status" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.Status ? "success" : "danger",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.Status ? "未開立" : "已開立") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.size,
              layout: "sizes, prev, pager, next",
              total: _vm.invoices.count,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "發票明細",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("h3", [_vm._v("品名: " + _vm._s(_vm.invoiceDetail.productName))]),
          _c("h3", [_vm._v("單價: " + _vm._s(_vm.invoiceDetail.unityPrice))]),
          _c("h3", [_vm._v("支付方式: " + _vm._s(_vm.invoiceSale.PayType))]),
          _c("h3", [_vm._v("交易時間: " + _vm._s(_vm.invoiceSale.UploadTime))]),
          _c("h3", [_vm._v("開立方式: " + _vm._s(_vm.invoiceDetail.type))]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }